import scrollAnimation from '../modules/scroll-animation.js'

export default function () {
    window.addEventListener('load', function () {
        const stickyScrollElements = document.querySelectorAll('.dr-sticky-scroll');
        stickyScrollElements.forEach(stickyScroll => {
            const videoIdList = stickyScroll.dataset.videos ? stickyScroll.dataset.videos.split('|') : null;
            const triggerItems = stickyScroll.querySelectorAll('.dr-sticky-scroll-content');
            const stickyItemsWrap = stickyScroll.querySelector('.dr-sticky-scroll-element-container');
            const elements = {
                stickyScroll,
                triggerItems,
                stickyItemsWrap,
                videoIdList
            }
            scrollAnimation(elements);
        })

    });
}
